<!-- <input type="text" [placeholder]="placeHolder" class="input-box readonly-input card-background div-hover-effect"
    [(ngModel)]="modelObject.modelValue" (focus)="modelObject.oldValue = modelObject.modelValue"
    (keyup.enter)="updateAttributeValue(modelObject)" (blur)="updateAttributeValue(modelObject)" /> -->


<input [type]="type" [placeholder]="placeHolder" 
class="editable-field"
[class.saved]="saved"
[(ngModel)]="modelObject.modelValue" 
(focus)="modelObject.oldValue = modelObject.modelValue" 
(blur)= "updateAttributeValue(modelObject)"
(keydown)="onTyping()"
(keyup.enter)="updateAttributeValue(modelObject)"
/>